$(document).ready(function () {
  if (!customElements.get("custom-product-options")) {
    customElements.define(
      "custom-product-options",
      class CustomProductOptions extends HTMLElement {
        constructor() {
          super();

          var this2 = this;
          setData();
          $(".custom-option-input").change(function () {
            setData();
          });

          function setData() {
            var primaryval = $(
              '.custom-option-input[name="custom-option-tip-color"]:checked'
            ).attr("value");
            var secondaryval = $(
              '.custom-option-input[name="custom-option-overlay-color"]:checked'
            ).attr("value");
            var primarychange = Number(
              $(
                '.custom-option-input[name="custom-option-tip-color"]:checked'
              ).attr("data-primarychange")
            );
            var secondarychange = Number(
              $(
                '.custom-option-input[name="custom-option-overlay-color"]:checked'
              ).attr("data-secondarychange")
            );
            var primarysku = $(
              '.custom-option-input[name="custom-option-tip-color"]:checked'
            ).attr("data-skucode");
            var secondarysku = $(
              '.custom-option-input[name="custom-option-overlay-color"]:checked'
            ).attr("data-skucode");
            var curid = $(".main-product-varid").attr("value");
            console.log(curid);

            var cursku = $(
              '.variant-item-inner[data-varid="' + curid + '"]'
            ).attr("data-varsku");
            console.log(cursku);
            var customsku = cursku + primarysku + secondarysku;
            var curprice = Number(
              $(".product__info-wrapper")
                .find(".price__regular")
                .attr("data-price")
            ); 
            curprice =
              curprice +
              (curprice * primarychange) / 100 +
              (curprice * secondarychange) / 100;
            curprice = curprice - 5;
            $('input[name="properties[_TotalPrice]"]').attr("value", curprice);
            $('input[name="properties[Primary Color]"]').attr("value", primaryval);
            $('input[name="properties[Overlay Color]"]').attr(
              "value",
              secondaryval
            );
            $(".product__info-wrapper")
              .find(".price-item--regular")
              .html(Shopify.formatMoney(curprice));
            $('input[name="properties[SKU]"]').attr("value", customsku);

            // $('input[name="properties[_PreviewImage]"]').attr(
            //   "value",
            //   imageUrl
            // );
          }

          document.addEventListener("handleVariantChange", () => {
            setData();
          });

          function handleize(str) {
            return str
              .toLowerCase() // Convert to lowercase
              .trim() // Remove whitespace from ends
              .replace(/[^a-z0-9\s-]/g, "") // Remove non-alphanumeric characters
              .replace(/\s+/g, "-") // Replace spaces with hyphens
              .replace(/-+/g, "-"); // Remove multiple hyphens
          }

          this.initCanvas();

          document.addEventListener("initCanvas", () => {
            this2.initCanvas();
          });
        }

        initCanvas() {  
          const canvas = document.getElementById("canvas");
          const parent = document.getElementById("main-canvas-wrapper");
          canvas.width = parent.offsetWidth;
          canvas.height = parent.offsetHeight;
          const ctx = canvas.getContext("2d");

          const imageSources = {
            baseImage: $(".main-image-wrapper").attr("data-mainimage"),
            truckImage: $(".main-image-wrapper").attr("data-truckimage"),
            tipImage: $(".main-image-wrapper").attr("data-tipimage"),
            tipPolishedImage: $(".main-image-wrapper").attr(
              "data-tippolishedimage"
            ),
            overlayImage: $(".main-image-wrapper").attr("data-overlayimage"),
            overlayPolishedImage: $(".main-image-wrapper").attr(
              "data-overlaypolishedimage"
            ),
            screwImage: $(".main-image-wrapper").attr("data-screwimage"),
          };

          const images = {};
          let imagesLoaded = 0;
          const totalImages = Object.keys(imageSources).length;

          const checkAllImagesLoaded = () => {
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
              drawAll();
            }
          };

          for (let key in imageSources) {
            images[key] = new Image();
            images[key].onload = checkAllImagesLoaded;
            images[key].onerror = (e) => {
              checkAllImagesLoaded(); // prevent total lockup
            };
            images[key].src = imageSources[key];
          }

          function drawAll() {
            const primaryOption = $(
              '.custom-option-input[name="custom-option-tip-color"]:checked'
            );
            const secondaryOption = $(
              '.custom-option-input[name="custom-option-overlay-color"]:checked'
            );

            const primaryIsPolished = primaryOption.val() === "Polished";
            const secondaryIsPolished = secondaryOption.val() === "Polished";

            const primaryColor = primaryOption.attr("data-colorcode");
            const secondaryColor = secondaryOption.attr("data-colorcode");

            ctx.clearRect(0, 0, canvas.width, canvas.height);

            const scaleX = canvas.width / images.baseImage.width;
            const scaleY = canvas.height / images.baseImage.height;

            // Draw order:
            ctx.drawImage(images.baseImage, 0, 0, canvas.width, canvas.height);
            ctx.drawImage(images.truckImage, 0, 0, canvas.width, canvas.height);

            // Tip Image: Tinted or Polished
            if (primaryIsPolished) {
              ctx.drawImage(
                images.tipPolishedImage,
                0,
                0,
                canvas.width,
                canvas.height
              );
            } else {
              tintImageAndDrawScaled(
                images.tipImage,
                primaryColor,
                scaleX,
                scaleY
              );
            }   

            // Overlay Image: Tinted or Polished
            if (secondaryIsPolished) {
              ctx.drawImage(
                images.overlayPolishedImage,
                0,
                0,
                canvas.width,
                canvas.height
              );
            } else {
              tintImageAndDrawScaled(
                images.overlayImage,
                secondaryColor,
                scaleX,
                scaleY
              );
            }

            // Screw Image (always drawn)
            ctx.drawImage(images.screwImage, 0, 0, canvas.width, canvas.height);

            // Your blob logic unchanged...
            canvas.toBlob(function (blob) {
              const primarysku = primaryOption.attr("data-skucode");
              const secondarysku = secondaryOption.attr("data-skucode");
              const curid = $(".main-product-varid").val();
              const cursku = $(
                '.variant-item-inner[data-varid="' + curid + '"]'
              ).attr("data-varsku");

              const customsku = cursku + primarysku + secondarysku + ".jpg";
              const fileurl =
                "https://tso.co/cdn/shop/files/" +
                customsku +
                "?v=" +
                Math.floor(1_000_000_000 + Math.random() * 9_000_000_000);
              $('input[name="properties[_PreviewImage]"]').val(fileurl);
              $(".product-form__submit").attr("disabled", true);
 
              $.get(fileurl)
                .done(function () {
                  $(".product-form__submit").removeAttr("disabled");
                })
                .fail(function () {
                  const form = new FormData();
                  form.append("image", blob, customsku);
                  form.append("name", cursku + primarysku + secondarysku);
                  $.ajax({
                    url: "https://devapis.in/TSO/upload_image.php",
                    method: "POST",
                    data: form,
                    processData: false,
                    contentType: false,
                  }).done(function (response) {
                    const resp = JSON.parse(response);
                    const fileurl = resp.filepath;
                    const formdata = new FormData();
                    formdata.append("file", fileurl);
                    $.ajax({
                      url: "https://devapis.in/TSO/createFile.php",
                      method: "POST",
                      data: formdata,
                      processData: false,
                      contentType: false,
                    }).done(function () {
                      $(".product-form__submit").removeAttr("disabled");
                    });
                  });
                });
            }, "image/png");
          }

          function tintImageAndDrawScaled(image, colorHex, scaleX, scaleY) {
            const [rTint, gTint, bTint] = hexToRgb(colorHex);
            const offCanvas = document.createElement("canvas");
            offCanvas.width = image.width;
            offCanvas.height = image.height;
            const offCtx = offCanvas.getContext("2d");

            offCtx.drawImage(image, 0, 0);
            const imageData = offCtx.getImageData(
              0,
              0,
              image.width,
              image.height
            );
            const data = imageData.data;

            for (let i = 0; i < data.length; i += 4) {
              const alpha = data[i + 3];
              if (alpha > 0) {
                data[i] = (data[i] * rTint) / 255;
                data[i + 1] = (data[i + 1] * gTint) / 255;
                data[i + 2] = (data[i + 2] * bTint) / 255;
              }
            }

            offCtx.putImageData(imageData, 0, 0);
            ctx.drawImage(
              offCanvas,
              0,
              0,
              image.width,
              image.height,
              0,
              0,
              image.width * scaleX,
              image.height * scaleY
            );
          }

          function hexToRgb(hex) {
            const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(
              shorthandRegex,
              (_, r, g, b) => r + r + g + g + b + b
            );
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
              hex
            );
            return result
              ? [
                  parseInt(result[1], 16),
                  parseInt(result[2], 16),
                  parseInt(result[3], 16),
                ]
              : [0, 0, 0];
          }

          $(".custom-option-input").change(function () {
            drawAll();
          });
        }

        connectedCallback() {
          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
          };
          new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: "0px 0px 400px 0px",
          }).observe(this);
        }
      }
    );
  }
});

// $(document).ready(function () {
//   var curid = $(".main-product-varid").attr("value");
//             console.log(curid);

//             var cursku = $(
//               '.variant-item-inner[data-varid="' + curid + '"]'
//             ).attr("data-varsku");
//   const MAIN_SKU = cursku; // change to your product's main sku
//   const canvasW = 1000,
//     canvasH = 1000; // adjust to your actual image size

//   const primaryColors = [
//     { hex: "#d1d1d1", sku: "-R" },
//     { hex: "#353535", sku: "-1" },
//     { hex: "#252324", sku: "-2" },
//     { hex: "#ffffff", sku: "-3" },
//     { hex: "#cccccc", sku: "-P" },
//   ];

//   const secondaryColors = [
//     { hex: "#d1d1d1", sku: "-R" },
//     { hex: "#cccccc", sku: "-P" },
//     { hex: "#353535", sku: "-1" },
//     { hex: "#252324", sku: "-2" },
//     { hex: "#ffffff", sku: "-3" },
//     { hex: "#d3d3d3", sku: "-4" },
//     { hex: "#005bd3", sku: "-5" },
//     { hex: "#6300ac", sku: "-6" },
//     { hex: "#f61f1f", sku: "-7" },
//     { hex: "#c10606", sku: "-8" },
//     { hex: "#e7e4e4", sku: "-11" },
//   ];

//   // Layer image sources (from your DOM or static URLs)
//   const imageSources = {
//     baseImage: $(".main-image-wrapper").attr("data-mainimage"),
//     truckImage: $(".main-image-wrapper").attr("data-truckimage"),
//     tipImage: $(".main-image-wrapper").attr("data-tipimage"),
//     tipPolishedImage: $(".main-image-wrapper").attr("data-tippolishedimage"),
//     overlayImage: $(".main-image-wrapper").attr("data-overlayimage"),
//     overlayPolishedImage: $(".main-image-wrapper").attr(
//       "data-overlaypolishedimage"
//     ),
//     screwImage: $(".main-image-wrapper").attr("data-screwimage"),
//   };

//   // Helper: convert hex to RGB array
//   function hexToRgb(hex) {
//     hex = hex.replace(/^#/, "");
//     if (hex.length === 3)
//       hex = hex
//         .split("")
//         .map((x) => x + x)
//         .join("");
//     const num = parseInt(hex, 16);
//     return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
//   }

//   // Helper: tint a canvas image
//   function tintImage(baseImg, colorHex, w, h) {
//     const [rTint, gTint, bTint] = hexToRgb(colorHex);
//     const offCanvas = document.createElement("canvas");
//     offCanvas.width = w;
//     offCanvas.height = h;
//     const ctx = offCanvas.getContext("2d");
//     ctx.drawImage(baseImg, 0, 0, w, h);
//     const imgData = ctx.getImageData(0, 0, w, h);
//     const d = imgData.data;
//     for (let i = 0; i < d.length; i += 4) {
//       const alpha = d[i + 3];
//       if (alpha > 0) {
//         d[i] = (d[i] * rTint) / 255;
//         d[i + 1] = (d[i + 1] * gTint) / 255;
//         d[i + 2] = (d[i + 2] * bTint) / 255;
//       }
//     }
//     ctx.putImageData(imgData, 0, 0);
//     return offCanvas;
//   }

//   // Load all images (returns Promise)
//   function loadImages(sources) {
//     const keys = Object.keys(sources);
//     const imgs = {};
//     let loaded = 0;
//     return new Promise((resolve, reject) => {
//       keys.forEach((key) => {
//         imgs[key] = new Image();
//         imgs[key].crossOrigin = "Anonymous";
//         imgs[key].onload = () => {
//           loaded++;
//           if (loaded === keys.length) resolve(imgs);
//         };
//         imgs[key].onerror = (e) =>
//           reject(new Error(`Failed to load ${key}: ${sources[key]}`));
//         imgs[key].src = sources[key];
//       });
//     });
//   }

//   // Download utility (for single file, fallback if not using ZIP)
//   function downloadBlob(blob, fileName) {
//     const a = document.createElement("a");
//     a.download = fileName;
//     a.href = URL.createObjectURL(blob);
//     a.style.display = "none";
//     document.body.appendChild(a);
//     a.click();
//     setTimeout(() => {
//       URL.revokeObjectURL(a.href);
//       a.remove();
//     }, 200);
//   }

//   // Main generation function, supports ZIP or loose files
//   async function generateAndDownloadAllCombos(useZip = true) {
//     // If using ZIP, load JSZip via CDN
//     let JSZip;
//     if (useZip) {
//       JSZip = window.JSZip;
//       if (!JSZip) {
//         await new Promise((r) => {
//           const s = document.createElement("script");
//           s.src =
//             "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js";
//           s.onload = r;
//           document.head.appendChild(s);
//         });
//         JSZip = window.JSZip;
//       }
//     }

//     const images = await loadImages(imageSources);
//     const canvas = document.createElement("canvas");
//     canvas.width = canvasW;
//     canvas.height = canvasH;
//     const ctx = canvas.getContext("2d");
//     const files = [];

//     // For each possible variant:
//     for (let p of primaryColors) {
//       for (let s of secondaryColors) {
//         // --- Variant 1: Both TINTED (classic) ---
//         ctx.clearRect(0, 0, canvasW, canvasH);
//         ctx.drawImage(images.baseImage, 0, 0, canvasW, canvasH);
//         ctx.drawImage(images.truckImage, 0, 0, canvasW, canvasH);
//         ctx.drawImage(
//           tintImage(images.tipImage, p.hex, canvasW, canvasH),
//           0,
//           0,
//           canvasW,
//           canvasH
//         );
//         ctx.drawImage(
//           tintImage(images.overlayImage, s.hex, canvasW, canvasH),
//           0,
//           0,
//           canvasW,
//           canvasH
//         );
//         ctx.drawImage(images.screwImage, 0, 0, canvasW, canvasH);

//         let fileName = `${MAIN_SKU}${p.sku}${s.sku}.jpg`;
//         await new Promise((res) =>
//           canvas.toBlob(
//             (blob) => {
//               if (useZip) files.push({ name: fileName, blob });
//               else downloadBlob(blob, fileName);
//               res();
//             },
//             "image/jpeg",
//             0.92
//           )
//         );

//         // --- Variant 2: Polished TIP, Tinted OVERLAY ---
//         ctx.clearRect(0, 0, canvasW, canvasH);
//         ctx.drawImage(images.baseImage, 0, 0, canvasW, canvasH);
//         ctx.drawImage(images.truckImage, 0, 0, canvasW, canvasH);
//         ctx.drawImage(images.tipPolishedImage, 0, 0, canvasW, canvasH); // polished!
//         ctx.drawImage(
//           tintImage(images.overlayImage, s.hex, canvasW, canvasH),
//           0,
//           0,
//           canvasW,
//           canvasH
//         );
//         ctx.drawImage(images.screwImage, 0, 0, canvasW, canvasH);

//         fileName = `${MAIN_SKU}${p.sku}P${s.sku}.jpg`; // 'P' after primary = polished tip
//         await new Promise((res) =>
//           canvas.toBlob(
//             (blob) => {
//               if (useZip) files.push({ name: fileName, blob });
//               else downloadBlob(blob, fileName);
//               res();
//             },
//             "image/jpeg",
//             0.92
//           )
//         );

//         // --- Variant 3: Tinted TIP, Polished OVERLAY ---
//         ctx.clearRect(0, 0, canvasW, canvasH);
//         ctx.drawImage(images.baseImage, 0, 0, canvasW, canvasH);
//         ctx.drawImage(images.truckImage, 0, 0, canvasW, canvasH);
//         ctx.drawImage(
//           tintImage(images.tipImage, p.hex, canvasW, canvasH),
//           0,
//           0,
//           canvasW,
//           canvasH
//         );
//         ctx.drawImage(images.overlayPolishedImage, 0, 0, canvasW, canvasH); // polished!
//         ctx.drawImage(images.screwImage, 0, 0, canvasW, canvasH);

//         fileName = `${MAIN_SKU}${p.sku}${s.sku}P.jpg`; // 'P' after secondary = polished overlay
//         await new Promise((res) =>
//           canvas.toBlob(
//             (blob) => {
//               if (useZip) files.push({ name: fileName, blob });
//               else downloadBlob(blob, fileName);
//               res();
//             },
//             "image/jpeg",
//             0.92
//           )
//         );

//         // --- Variant 4: Polished TIP, Polished OVERLAY ---
//         ctx.clearRect(0, 0, canvasW, canvasH);
//         ctx.drawImage(images.baseImage, 0, 0, canvasW, canvasH);
//         ctx.drawImage(images.truckImage, 0, 0, canvasW, canvasH);
//         ctx.drawImage(images.tipPolishedImage, 0, 0, canvasW, canvasH); // polished!
//         ctx.drawImage(images.overlayPolishedImage, 0, 0, canvasW, canvasH); // polished!
//         ctx.drawImage(images.screwImage, 0, 0, canvasW, canvasH);

//         fileName = `${MAIN_SKU}${p.sku}P${s.sku}P.jpg`; // both polished
//         await new Promise((res) =>
//           canvas.toBlob(
//             (blob) => {
//               if (useZip) files.push({ name: fileName, blob });
//               else downloadBlob(blob, fileName);
//               res();
//             },
//             "image/jpeg",
//             0.92
//           )
//         );
//       }
//     }

//     // Save ZIP if requested
//     if (useZip) {
//       const zip = new JSZip();
//       files.forEach((f) => zip.file(f.name, f.blob));
//       zip.generateAsync({ type: "blob" }).then((zipBlob) => {
//         downloadBlob(zipBlob, MAIN_SKU + "_all_combos.zip");
//         alert("Download ready! All images zipped.");
//       });
//     } else {
//       alert("Download ready! All images downloaded.");
//     }
//   }

//   generateAndDownloadAllCombos(true);
// });
